"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sagas;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _clearSuggestedActionsOnPostActivitySaga = _interopRequireDefault(require("./sagas/clearSuggestedActionsOnPostActivitySaga"));

var _connectionStatusToNotificationSaga = _interopRequireDefault(require("./sagas/connectionStatusToNotificationSaga"));

var _connectionStatusUpdateSaga = _interopRequireDefault(require("./sagas/connectionStatusUpdateSaga"));

var _connectSaga = _interopRequireDefault(require("./sagas/connectSaga"));

var _detectSlowConnectionSaga = _interopRequireDefault(require("./sagas/detectSlowConnectionSaga"));

var _emitTypingIndicatorToPostActivitySaga = _interopRequireDefault(require("./sagas/emitTypingIndicatorToPostActivitySaga"));

var _markAllAsSpokenOnStopSpeakActivitySaga = _interopRequireDefault(require("./sagas/markAllAsSpokenOnStopSpeakActivitySaga"));

var _observeActivitySaga = _interopRequireDefault(require("./sagas/observeActivitySaga"));

var _postActivitySaga = _interopRequireDefault(require("./sagas/postActivitySaga"));

var _queueIncomingActivitySaga = _interopRequireDefault(require("./sagas/queueIncomingActivitySaga"));

var _sendEventToPostActivitySaga = _interopRequireDefault(require("./sagas/sendEventToPostActivitySaga"));

var _sendFilesToPostActivitySaga = _interopRequireDefault(require("./sagas/sendFilesToPostActivitySaga"));

var _sendMessageBackToPostActivitySaga = _interopRequireDefault(require("./sagas/sendMessageBackToPostActivitySaga"));

var _sendMessageToPostActivitySaga = _interopRequireDefault(require("./sagas/sendMessageToPostActivitySaga"));

var _sendPostBackToPostActivitySaga = _interopRequireDefault(require("./sagas/sendPostBackToPostActivitySaga"));

var _sendTypingIndicatorOnSetSendBoxSaga = _interopRequireDefault(require("./sagas/sendTypingIndicatorOnSetSendBoxSaga"));

var _speakActivityAndStartDictateOnIncomingActivityFromOthersSaga = _interopRequireDefault(require("./sagas/speakActivityAndStartDictateOnIncomingActivityFromOthersSaga"));

var _startDictateOnSpeakCompleteSaga = _interopRequireDefault(require("./sagas/startDictateOnSpeakCompleteSaga"));

var _startSpeakActivityOnPostActivitySaga = _interopRequireDefault(require("./sagas/startSpeakActivityOnPostActivitySaga"));

var _stopDictateOnCardActionSaga = _interopRequireDefault(require("./sagas/stopDictateOnCardActionSaga"));

var _stopSpeakingActivityOnInputSaga = _interopRequireDefault(require("./sagas/stopSpeakingActivityOnInputSaga"));

var _submitSendBoxSaga = _interopRequireDefault(require("./sagas/submitSendBoxSaga"));

var _marked = /*#__PURE__*/_regenerator["default"].mark(sagas);

function sagas() {
  return _regenerator["default"].wrap(function sagas$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.fork)(_clearSuggestedActionsOnPostActivitySaga["default"]);

        case 2:
          _context.next = 4;
          return (0, _effects.fork)(_connectionStatusToNotificationSaga["default"]);

        case 4:
          _context.next = 6;
          return (0, _effects.fork)(_connectionStatusUpdateSaga["default"]);

        case 6:
          _context.next = 8;
          return (0, _effects.fork)(_connectSaga["default"]);

        case 8:
          _context.next = 10;
          return (0, _effects.fork)(_detectSlowConnectionSaga["default"]);

        case 10:
          _context.next = 12;
          return (0, _effects.fork)(_emitTypingIndicatorToPostActivitySaga["default"]);

        case 12:
          _context.next = 14;
          return (0, _effects.fork)(_markAllAsSpokenOnStopSpeakActivitySaga["default"]);

        case 14:
          _context.next = 16;
          return (0, _effects.fork)(_observeActivitySaga["default"]);

        case 16:
          _context.next = 18;
          return (0, _effects.fork)(_postActivitySaga["default"]);

        case 18:
          _context.next = 20;
          return (0, _effects.fork)(_queueIncomingActivitySaga["default"]);

        case 20:
          _context.next = 22;
          return (0, _effects.fork)(_sendEventToPostActivitySaga["default"]);

        case 22:
          _context.next = 24;
          return (0, _effects.fork)(_sendFilesToPostActivitySaga["default"]);

        case 24:
          _context.next = 26;
          return (0, _effects.fork)(_sendMessageBackToPostActivitySaga["default"]);

        case 26:
          _context.next = 28;
          return (0, _effects.fork)(_sendMessageToPostActivitySaga["default"]);

        case 28:
          _context.next = 30;
          return (0, _effects.fork)(_sendPostBackToPostActivitySaga["default"]);

        case 30:
          _context.next = 32;
          return (0, _effects.fork)(_sendTypingIndicatorOnSetSendBoxSaga["default"]);

        case 32:
          _context.next = 34;
          return (0, _effects.fork)(_speakActivityAndStartDictateOnIncomingActivityFromOthersSaga["default"]);

        case 34:
          _context.next = 36;
          return (0, _effects.fork)(_startDictateOnSpeakCompleteSaga["default"]);

        case 36:
          _context.next = 38;
          return (0, _effects.fork)(_startSpeakActivityOnPostActivitySaga["default"]);

        case 38:
          _context.next = 40;
          return (0, _effects.fork)(_stopDictateOnCardActionSaga["default"]);

        case 40:
          _context.next = 42;
          return (0, _effects.fork)(_stopSpeakingActivityOnInputSaga["default"]);

        case 42:
          _context.next = 44;
          return (0, _effects.fork)(_submitSendBoxSaga["default"]);

        case 44:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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